class Brands {
    constructor(item) {
        // Переменные
        this.element = item;
        this.letters = this.element.querySelector('.js-brands-letters');
        this.content = this.element.querySelector('.js-brands-content');
        this.listBtn = this.element.querySelector('.js-brands-list');
        this.gridBtn = this.element.querySelector('.js-brands-grid');
        this.selector = this.element.querySelector('.js-selector');

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.listBtn.addEventListener('click', () => {
            this.listBtn.classList.add('is-active');
            this.gridBtn.classList.remove('is-active');

            this.content.classList.remove('is-grid');
            this.letters.classList.remove('is-grid');
        });

        this.gridBtn.addEventListener('click', () => {
            this.gridBtn.classList.add('is-active');
            this.listBtn.classList.remove('is-active');

            this.content.classList.add('is-grid');
            this.letters.classList.add('is-grid');
        });

        NiceSelect.bind(this.selector, {searchable: false});
    }
};

document.querySelectorAll('.js-brands').forEach((item) => new Brands(item));
